/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { Agency } from "../model"
// @ts-ignore
import type { Bank } from "../model"
/**
 * FundingResourceApi - axios parameter creator
 */
export const FundingResourceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get agencies
     * @param {string} [bankCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAgencies: async (
      bankCode?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v2.0/funding/agency`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (bankCode !== undefined) {
        localVarQueryParameter["bankCode"] = bankCode
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get agency by id
     * @param {string} agencyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAgency: async (
      agencyId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'agencyId' is not null or undefined
      assertParamExists("getAgency", "agencyId", agencyId)
      const localVarPath = `/v2.0/funding/bank-partner/{agencyId}`.replace(
        "{agencyId}",
        encodeURIComponent(String(agencyId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get bank partner by id
     * @param {string} bankId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBankPartner: async (
      bankId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'bankId' is not null or undefined
      assertParamExists("getBankPartner", "bankId", bankId)
      const localVarPath = `/v2.0/funding/bank-partner/{bankId}`.replace(
        "{bankId}",
        encodeURIComponent(String(bankId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get bank partners
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBankPartners: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/v2.0/funding/bank-partner`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * FundingResourceApi - functional programming interface
 */
export const FundingResourceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FundingResourceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get agencies
     * @param {string} [bankCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAgencies(
      bankCode?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Agency>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAgencies(bankCode, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FundingResourceApi.getAgencies"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get agency by id
     * @param {string} agencyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAgency(
      agencyId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Agency>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAgency(agencyId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FundingResourceApi.getAgency"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get bank partner by id
     * @param {string} bankId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBankPartner(
      bankId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Bank>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getBankPartner(bankId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FundingResourceApi.getBankPartner"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get bank partners
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBankPartners(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Bank>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getBankPartners(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FundingResourceApi.getBankPartners"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * FundingResourceApi - factory interface
 */
export const FundingResourceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = FundingResourceApiFp(configuration)
  return {
    /**
     *
     * @summary Get agencies
     * @param {FundingResourceApiGetAgenciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAgencies(
      requestParameters: FundingResourceApiGetAgenciesRequest = {},
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<Agency>> {
      return localVarFp
        .getAgencies(requestParameters.bankCode, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get agency by id
     * @param {FundingResourceApiGetAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAgency(
      requestParameters: FundingResourceApiGetAgencyRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Agency> {
      return localVarFp
        .getAgency(requestParameters.agencyId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get bank partner by id
     * @param {FundingResourceApiGetBankPartnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBankPartner(
      requestParameters: FundingResourceApiGetBankPartnerRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Bank> {
      return localVarFp
        .getBankPartner(requestParameters.bankId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get bank partners
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBankPartners(options?: RawAxiosRequestConfig): AxiosPromise<Array<Bank>> {
      return localVarFp.getBankPartners(options).then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for getAgencies operation in FundingResourceApi.
 */
export interface FundingResourceApiGetAgenciesRequest {
  readonly bankCode?: string
}

/**
 * Request parameters for getAgency operation in FundingResourceApi.
 */
export interface FundingResourceApiGetAgencyRequest {
  readonly agencyId: string
}

/**
 * Request parameters for getBankPartner operation in FundingResourceApi.
 */
export interface FundingResourceApiGetBankPartnerRequest {
  readonly bankId: string
}

/**
 * FundingResourceApi - object-oriented interface
 */
export class FundingResourceApi extends BaseAPI {
  /**
   *
   * @summary Get agencies
   * @param {FundingResourceApiGetAgenciesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getAgencies(
    requestParameters: FundingResourceApiGetAgenciesRequest = {},
    options?: RawAxiosRequestConfig
  ) {
    return FundingResourceApiFp(this.configuration)
      .getAgencies(requestParameters.bankCode, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get agency by id
   * @param {FundingResourceApiGetAgencyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getAgency(
    requestParameters: FundingResourceApiGetAgencyRequest,
    options?: RawAxiosRequestConfig
  ) {
    return FundingResourceApiFp(this.configuration)
      .getAgency(requestParameters.agencyId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get bank partner by id
   * @param {FundingResourceApiGetBankPartnerRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getBankPartner(
    requestParameters: FundingResourceApiGetBankPartnerRequest,
    options?: RawAxiosRequestConfig
  ) {
    return FundingResourceApiFp(this.configuration)
      .getBankPartner(requestParameters.bankId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get bank partners
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getBankPartners(options?: RawAxiosRequestConfig) {
    return FundingResourceApiFp(this.configuration)
      .getBankPartners(options)
      .then(request => request(this.axios, this.basePath))
  }
}
